import { getCookie } from 'cookies-next';
import mixpanel, { Dict } from 'mixpanel-browser';

const isProduction = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production';

const getLemonDistinctId = () => {
  try {
    const lmn_distinct_id = getCookie('lmn_distinct_id');

    if (typeof lmn_distinct_id !== 'string') {
      return null;
    }

    return lmn_distinct_id;
  } catch (e) {
    if (!isProduction) {
      console.error(e);
    }

    return null;
  }
};

const MixpanelService = {
  init: () => {
    try {
      if (!isProduction) {
        console.log({
          isProduction,
          environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
        });
      }

      mixpanel.init(
        process.env.MIXPANEL_PROJECT_TOKEN ||
          'a0c43160b0b28d44a21e40969a5cdadd',
        {
          debug: !isProduction,
          api_host: `${window.location.origin}/mp`,
          ignore_dnt: true,
        }
      );

      const lemonDistinctId = getLemonDistinctId();

      if (lemonDistinctId) {
        mixpanel.identify(lemonDistinctId);
      }
    } catch (err) {
      if (!isProduction) {
        console.error('Mixpanel init error:', err);
      }
    }
  },

  createAlias: (alias: string, original: string) => {
    try {
      return mixpanel.alias(alias, original);
    } catch (err) {
      if (!isProduction) {
        console.error('Mixpanel creating alias error:', err);
      }
    }
  },

  getDistinctId: () => {
    try {
      return mixpanel.get_distinct_id().replace('$device:', '');
    } catch (err) {
      if (!isProduction) {
        console.error('Mixpanel getting distinct id error:', err);
      }
    }
  },

  identify: () => {
    try {
      mixpanel.identify();
    } catch (err) {
      if (!isProduction) {
        console.error('Mixpanel identification error:', err);
      }
    }
  },

  setPropertiesOnUser: (props: Dict) => {
    try {
      mixpanel.people.set(props);
    } catch (err) {
      if (!isProduction) {
        console.error('Mixpanel setting propertiers on user error:', err);
      }
    }
  },

  addEvent: (event_name: string, props?: Dict) => {
    try {
      mixpanel?.track(event_name, props);
    } catch (err) {
      if (!isProduction) {
        console.error('Mixpanel event error:', err);
      }
    }
  },

  addButtonClickEvent: (buttonName: string) => {
    try {
      mixpanel?.track('magic-lemon_button_clicked', {
        button_name: buttonName,
        page_name: window.location.pathname,
      });
    } catch (err) {
      if (!isProduction) {
        console.error('Mixpanel button click event error:', err);
      }
    }
  },

  addSuperProperty: (props: Dict, days?: number) => {
    try {
      mixpanel?.register(props, days);
    } catch (err) {
      if (!isProduction) {
        console.error('Mixpanel super-property error:', err);
      }
    }
  },
};

export default MixpanelService;
